import React, { Fragment, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import TestimonyProgramBox from './TestimonyProgramBox';
import { resetState } from '../../../Features/Learning/TestimonyProgram/addTestimonyProgramSlice';
import { useSelector, useDispatch } from 'react-redux';
import { Btn } from '../../../AbstractElements';
import TestimonyProgramFilter from './TestimonyProgramFilter';

const TestimonyProgramContain = () => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const cards = useSelector(state => state.testimonyProgram.data.data)

  const toggle = () => setModal(prev => !prev);

  const handleAdd = (e) => {
    dispatch(resetState());
  };

  console.log(modal)

  return (
    <Fragment>
      <Container fluid={true}>
        <Col md="12" className="project-list">
          {cards && (
            <Card>
              <Row>
                <Col>
                  {/* <Link to={`${process.env.PUBLIC_URL}/testimony-program/form`} onClick={handleAdd}> */}
                  <Button color="primary" onClick={e => {
                    e.preventDefault();
                    handleAdd(e);
                    toggle();
                  }}>
                    <i className="fa fa-plus-circle fa-lg"></i> Tambah Testimoni Baru
                  </Button>
                  {/* </Link> */}
                </Col>
              </Row>
            </Card>
          )}
        </Col>
        <Row className='learning-block'>
          <Col xl="9" className='xl-80'>
            <Row>
              <TestimonyProgramBox modal={modal} toggle={toggle} />
            </Row>
          </Col>
          {cards && (
            <TestimonyProgramFilter />
          )}
        </Row>
      </Container>
    </Fragment>
  );
};

export default TestimonyProgramContain;